module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"from":"от","to":"до","notProvided":"не указана","year":"в год","month":"в месяц","week":"в неделю","day":"в день","hour":"в час","net":"до вычета НДФЛ","gross":"на руки"}}')
  delete Component.options._Ctor
}
